import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginVertical: 15,
  },
  loading: {
    marginBottom: 10,
  },
  positionType: {
    marginTop: -15,
    borderBottomWidth: 1,
    borderBottomColor: PALETTE.primaryStrokeLine,
    marginRight: 0,
    marginLeft: 0,
    paddingTop: 3,
    paddingBottom: 3,
    justifyContent: 'center',
    flexDirection: 'row',
    flex: 1,
  },
  positionTypeText: {
    color: PALETTE.primaryTextDisabled,
  },
});
